// extracted by mini-css-extract-plugin
export default {"submenu":"SettingsSubmenu_submenu__lqMO3"};